import { render } from "./NeuFooterSektion.vue?vue&type=template&id=3f10ca67&scoped=true"
import script from "./NeuFooterSektion.vue?vue&type=script&lang=js"
export * from "./NeuFooterSektion.vue?vue&type=script&lang=js"

import "./NeuFooterSektion.vue?vue&type=style&index=0&id=3f10ca67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f10ca67"]])

export default __exports__